// src/components/Sections/LaunchStatusSection/LaunchStatusSection.jsx

import React from 'react';
import './LaunchStatusSection.scss';

export default function LaunchStatusSection() {
  return (
    <section id="launch" className="launch-status section-v2">
      <div className="container launch-status__layout">
        <div className="launch-status__intro">
          <p className="eyebrow">Built today · Growing for 2027</p>
          <h2>A working platform. A founding club in the making.</h2>
          <p>
            The on-course technology is already being developed and tested.
            Our next step is growing the member community, course relationships,
            and repeatable events in the Greater Toronto Area for the 2027 season.
          </p>
        </div>
        <div className="launch-status__details">
          <div className="launch-status__item">
            <span>THE PLATFORM</span>
            <strong>Built and being refined</strong>
            <p>iOS and Apple Watch, scoring, golf history, Groups, Tour Series, and community features.</p>
          </div>
          <div className="launch-status__item">
            <span>THE FOUNDING COMMUNITY</span>
            <strong>Building toward 2027</strong>
            <p>Starting in the GTA and Southern Ontario, with member feedback shaping the first club experiences.</p>
          </div>
          <div className="launch-status__item">
            <span>REAL-WORLD EXPERIENCES</span>
            <strong>Planned as the club grows</strong>
            <p>Member rounds, watch parties, simulator gatherings, and course partnerships are goals—not included bookings today.</p>
          </div>
          <a className="text-link launch-status__link" href="#contact">
            Request founding updates <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
